exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.extra-space[data-v-a9520fc8]{\n  margin: -14px 0 10px !important;\n}\n", ""]);

// exports
